import { normalizeC4ContractStatus } from '@/components/Financeiro/financeC4ContractStatus'
import type { FinanceRequestDetail } from '@/services/financeService'

export type ComercialChamadoPendingKind = 'adjust_proposal' | 'respond_comments'

export const COMERCIAL_CHAMADO_CONVERSA_SECTION_ID = 'chamado-conversa'

const PENDING_STATUSES: Record<string, ComercialChamadoPendingKind> = {
  AJUSTAR_PROPOSTA: 'adjust_proposal',
  AGUARDANDO_SOLICITANTE: 'respond_comments',
}

export function resolveComercialChamadoPending(input: {
  type: string
  status: string
}): ComercialChamadoPendingKind | null {
  if (input.type !== 'C4_CONTRATO_AGRADA') return null
  const normalized = normalizeC4ContractStatus(input.status)
  return PENDING_STATUSES[normalized] ?? null
}

export function isComercialChamadoPendingAction(type: string, status: string): boolean {
  return resolveComercialChamadoPending({ type, status }) !== null
}

export function resolveChamadoLinkedDealId(detail: FinanceRequestDetail): string | null {
  const fromProject = detail.project?.deal?.id
  if (fromProject) return fromProject
  const raw = detail.formData?.linkedDealId
  return typeof raw === 'string' && raw.trim() ? raw.trim() : null
}

export function comercialChamadoPendingCopy(kind: ComercialChamadoPendingKind): {
  title: string
  description: string
} {
  if (kind === 'adjust_proposal') {
    return {
      title: 'Ajuste de proposta pendente',
      description:
        'O financeiro pediu alterações na proposta antes de seguir com o contrato. Abra o negócio, revise os itens e salve a proposta atualizada.',
    }
  }
  return {
    title: 'Resposta pendente',
    description:
      'O financeiro aguarda sua resposta neste chamado. Leia a conversa abaixo e envie a informação ou confirmação solicitada.',
  }
}
